import { Publish } from '@mui/icons-material';
import { MenuItem, Typography } from '@mui/material';
import { SITUACAO_PUBLICACAO_PAUTA } from '@/dominio/SituacaoPublicacaoPauta';
import { action, computed, makeObservable } from 'mobx';
import { inject, observer } from 'mobx-react';
import ReactComponent from '../ReactComponent';

class AlertaLiberacaoPublicacao extends ReactComponent {
    constructor(props) {
        super(props);

        makeObservable(this, {
            quantidade: computed,
            handleClickIcone: action,
            descricao: computed
        });
    }

    get quantidade() {
        return this.store.processosPautaSelecionada.filter((registro) => !registro.confirmadaPublicacaoPauta).length;
    }

    handleClickIcone = () => {
        this.store.alterarProcessosEmExibicao('P');
        this.store.alterandoValorFiltro = true;
        this.setTimeout(() => {
            this.store.filtros.reset();
            this.store.filtros.filtroSituacaoPublicacaoPauta.valor =
                SITUACAO_PUBLICACAO_PAUTA.NAO_LIBERADO_PUBLICACAO.id;
            this.store.alterandoValorFiltro = false;
        }, 1);
    };

    get descricao() {
        return (
            this.quantidade + (this.quantidade === 1 ? ' processo' : ' processos') + ' sem liberação para publicação'
        );
    }

    render() {
        if (!this.quantidade) {
            return null;
        }

        return (
            <MenuItem
                style={{ display: 'flex', cursor: 'pointer' }}
                onClick={this.handleClickIcone}
            >
                <Publish style={{ marginRight: '12px', color: 'darkorange', fillOpacity: '1' }} />
                <Typography>{this.descricao}</Typography>
            </MenuItem>
        );
    }
}

export default inject('stores')(observer(AlertaLiberacaoPublicacao));
